import { _ as _objectSpread2 } from './focus-057f85ef.esm.js';
import _omit from 'ramda/src/omit';
import _evolve from 'ramda/src/evolve';
import { extendTheme, theme as theme$1, ChakraProvider } from '@chakra-ui/react';
import { c as components, _ as _objectWithoutProperties } from './index-8c67a5ac.esm.js';
import { f as foundations } from './index-33f4c880.esm.js';
import 'react';
import { jsx } from '@emotion/react/jsx-runtime';
import '@hover/blueprint-theme';
import 'ramda/src/mergeDeepRight';
import '@hover/tokens-typography';
import 'ramda/src/mapObjIndexed';
import 'polished';
import 'ramda/src/pick';
import '@hover/blueprint-theme/components';
import 'ramda/src/mergeDeepWith';
import '@hover/utilities';
import 'ramda/src/max';
import 'ramda/src/reduce';
import 'ramda/src/prop';
import '@chakra-ui/theme-tools';

/**
 * List of components to omit from the base theme. These components will not
 * receive any theming from Chakra, and instead will be themed entirely in this
 * theme. This is useful for cases where we find ourselves overwriting portions
 * of the Chakra theme just to disable the default appearance.
 */
var componentsToOmit = ['Button', 'Code', 'Checkbox', 'Input', 'Radio', 'Select', 'Textarea'];

var baseTheme = /*#__PURE__*/_evolve({
  components: /*#__PURE__*/_omit(componentsToOmit)
}, theme$1);

var theme = /*#__PURE__*/extendTheme( /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, foundations), {}, {
  components: components
}), baseTheme);
theme.config.cssVarPrefix = 'hover';
theme.styles.global = {};

var _excluded = ["children", "resetCSS"];

var Provider = function Provider(_ref) {
  var children = _ref.children,
      _ref$resetCSS = _ref.resetCSS,
      resetCSS = _ref$resetCSS === void 0 ? false : _ref$resetCSS,
      props = _objectWithoutProperties(_ref, _excluded);

  return jsx(ChakraProvider, _objectSpread2(_objectSpread2({}, props), {}, {
    resetCSS: resetCSS,
    theme: theme,
    children: children
  }));
};

export { Provider, theme };
